const PROD_URL_BASE =
  "https://us-central1-waitlist-app-3154b.cloudfunctions.net/api";
const STAGING_URL_BASE =
  "https://us-central1-resto-guru-staging.cloudfunctions.net/api";
const DEV_URL_BASE =
  "https://us-central1-waitlist-app-dev.cloudfunctions.net/api";
const LOCAL_URL_BASE = "http://localhost:5051";
const MATT_URL_BASE =
  "https://us-central1-resto-guru-matt.cloudfunctions.net/api";

export default function getUrlBase() {
  switch (process.env.REACT_APP_TARGET) {
    case "prod":
      return PROD_URL_BASE;
    case "staging":
      return STAGING_URL_BASE;
    case "local":
      return LOCAL_URL_BASE;
    case "matt":
      return MATT_URL_BASE;
    case "dev":
    default:
      return DEV_URL_BASE;
  }
}
